import {
    FETCH_ADDONS,
    FETCH_ADDONS_SUCCESS,
    FETCH_ADDONS_FAILED,
    EDIT_ADDONS
  } from "../store/types";
  
  const INITIAL_STATE = {
    addons: null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const addonsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ADDONS:
        return {
          ...state,
          loading: true
        };
      case FETCH_ADDONS_SUCCESS:
        return {
          ...state,
          addons: action.payload,
          loading: false
        };
      case FETCH_ADDONS_FAILED:
        return {
          ...state,
          addons: null,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case EDIT_ADDONS:
        return state;
      default:
        return state;
    }
  }; 